import {HTMLAttributes} from 'react';
import {Button} from '../../atoms/Button/Button';
import {ButtonColorScheme, ButtonSize} from '../../atoms/Button/Button.enum';
import {ButtonV2} from '../../atoms/ButtonV2/ButtonV2';
import {
  ButtonV2Size,
  ButtonV2Variant,
} from '../../atoms/ButtonV2/ButtonV2.enum';
import {ErrorAreaChildProps} from './ErrorAreaChildProps.interface';
import {useErrorAreaContext} from './ErrorAreaContext';

export function ErrorAreaLabelButton({
  children,
  isRound = true,
  ...props
}: {isRound?: boolean} & ErrorAreaChildProps &
  HTMLAttributes<HTMLButtonElement>) {
  const {isMobile, isPopupWindow} = useErrorAreaContext();

  // PC 팝업창은 360~500 사이즈로 모바일 뷰처럼 작은 창으로 표시됨 (openWindow 함수 참고)
  if (isMobile || isPopupWindow) {
    return (
      <Button
        {...props}
        colorScheme={ButtonColorScheme['2nd']}
        isRound={isRound}
        size={ButtonSize.Medium}
      >
        {children}
      </Button>
    );
  }

  return (
    <ButtonV2
      {...props}
      size={ButtonV2Size.Large}
      variant={ButtonV2Variant.Primary}
    >
      {children}
    </ButtonV2>
  );
}

export const ErrorAreaLabelButtonType = (<ErrorAreaLabelButton />).type;
